// De taal van de pagina en de vertalingen voor teksten die een script zelf schrijft.
// De Nederlandse tekst is de sleutel: t('Morgen') geeft op /de "Morgen" en op /en "Tomorrow".
// De vertalingen staan als JSON in de layout (#renoco-taal), alleen op de Duitse en Engelse site;
// ze komen uit resources/lang/de.json en en.json (zie de tag {{ taal:js }}).

export const taal = (document.documentElement.lang || 'nl').slice(0, 2);

// Het voorvoegsel van adressen in deze taal: "" voor Nederlands, "/de" of "/en".
export const voorvoegsel = taal === 'nl' ? '' : `/${taal}`;

// Voor datums en getallen (Intl): maand- en dagnamen in de taal van de pagina.
export const landcode = { nl: 'nl-NL', de: 'de-DE', en: 'en-GB' }[taal] ?? 'nl-NL';

let teksten = null;

function lees() {
    if (teksten === null) {
        try {
            teksten = JSON.parse(document.getElementById('renoco-taal')?.textContent || '{}');
        } catch (e) {
            teksten = {};
        }
    }

    return teksten;
}

// Vertaalt een vaste tekst. Plekken als ":tijd" worden gevuld met de meegegeven waarden.
export function t(tekst, waarden = {}) {
    let uit = lees()[tekst] ?? tekst;

    for (const [naam, waarde] of Object.entries(waarden)) {
        uit = uit.split(`:${naam}`).join(String(waarde));
    }

    return uit;
}

// Een productnaam midden in een zin: in het Nederlands en Engels met kleine letter, in het Duits niet.
export function inZin(naam) {
    return taal === 'de' ? String(naam) : String(naam).toLowerCase();
}

if (typeof window !== 'undefined') {
    window.renocoTaal = { taal, voorvoegsel, t };
}

// Een prijs zoals de taal hem schrijft: € 1.299 (nl), 1.299 € (de), €1,299 (en). Hele euro's zonder decimalen.
export function prijs(bedrag, teken = '€') {
    const getal = parseFloat(bedrag) || 0;
    const heel = Number.isInteger(getal);
    const cijfers = getal.toLocaleString(landcode, { minimumFractionDigits: heel ? 0 : 2, maximumFractionDigits: heel ? 0 : 2 });

    if (taal === 'de') return `${cijfers} ${teken}`;
    if (taal === 'en') return `${teken}${cijfers}`;

    return `${teken} ${cijfers}`;
}
